export default __webpack_public_path__ + "assets/resizedpopularCities_1-min.3fb66367.webp";